import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function DocsHubPage() {
  return <div className="min-h-screen flex flex-col bg-[#F1F5F9]" data-id="element-473">

      {/* Nav */}
      <header className="fixed top-0 left-0 right-0 z-[1000] bg-[#F1F5F9]/90 backdrop-blur-xl border-b border-[#0F172A]/[0.08]" data-id="element-474">
        <div className="flex items-center justify-between py-4 max-w-[1200px] mx-auto px-6" data-id="element-475">
          <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-[#0F172A] no-underline" data-id="element-476">
            <img src="https://assets.corkship.io/CorkShip%20Logo%20Original%20png.png" alt="CorkShip" className="w-8 h-8 object-contain" data-id="element-477" />
            CorkShip
          </Link>
          <span className="hidden md:inline text-sm text-[#64748B] font-medium" data-id="element-478">Documentation</span>
        </div>
      </header>

      {/* Hero */}
      <div className="pt-[80px] bg-[#0F172A] text-white" data-id="element-479">
        <div className="max-w-[1200px] mx-auto px-6 py-16 text-center" data-id="element-480">
          <div className="flex items-center justify-center gap-2 text-sm text-white/50 mb-4" data-id="element-481">
            <Link to="/" className="text-white/50 hover:text-white no-underline transition-colors" data-id="element-482">CorkShip</Link>
            <span data-id="element-483">/</span>
            <span className="text-white" data-id="element-484">Documentation</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-485">Documentation</h1>
          <p className="text-white/70 text-lg max-w-[480px] mx-auto leading-relaxed" data-id="element-486">Choose your platform to get started with CorkShip.</p>
        </div>
      </div>

      {/* Platform cards */}
      <div className="flex-1 max-w-[860px] mx-auto px-6 py-16 w-full" data-id="element-487">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-488">

          {/* Shopify */}
          <Link to="/docs/shopify" className="no-underline group" data-id="element-489">
            <div className="bg-white rounded-2xl border border-[#E2E8F0] p-8 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-xl h-full flex flex-col" data-id="element-490">
              <div className="flex items-center gap-3 mb-5" data-id="element-491">
                <div className="w-12 h-12 rounded-xl bg-[#5E8E3E]/10 flex items-center justify-center flex-shrink-0" data-id="element-492">
                  <svg viewBox="0 0 24 24" fill="#5E8E3E" className="w-6 h-6" data-id="element-493">
                    <path d="M15.337 3.415c-.157-.018-.314.064-.392.203-.078.14-.048.317.073.427.744.683 1.18 1.595 1.18 2.455 0 1.903-1.627 3.5-3.5 3.5s-3.5-1.597-3.5-3.5c0-.86.436-1.772 1.18-2.455.12-.11.15-.287.072-.427-.078-.14-.235-.22-.392-.203C6.996 3.7 4.5 6.585 4.5 10c0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-3.415-2.496-6.3-4.163-6.585z" data-id="element-494" />
                  </svg>
                </div>
                <div data-id="element-495">
                  <p className="font-heading text-lg font-bold text-[#0F172A]" data-id="element-496">Shopify</p>
                  <p className="text-xs text-[#64748B]" data-id="element-497">Install from the Shopify App Store</p>
                </div>
              </div>
              <p className="text-[#475569] text-sm leading-relaxed flex-1" data-id="element-498">Get CorkShip set up in your Shopify store. Covers installation, Australia Post credentials, parcel sizes, shipping labels, postcode validation, and manifests.</p>
              <div className="flex items-center gap-1.5 text-[#0284C7] text-sm font-semibold mt-6 group-hover:gap-2.5 transition-all" data-id="element-499">
                Read the Shopify guide
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4" data-id="element-500"><path d="M5 12h14" data-id="element-501" /><path d="M12 5l7 7-7 7" data-id="element-502" /></svg>
              </div>
            </div>
          </Link>

          {/* Commerce7 */}
          <Link to="/docs/commerce7" className="no-underline group" data-id="element-503">
            <div className="bg-white rounded-2xl border border-[#E2E8F0] p-8 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-xl h-full flex flex-col" data-id="element-504">
              <div className="flex items-center gap-3 mb-5" data-id="element-505">
                <div className="w-12 h-12 rounded-xl bg-[#6B21A8]/10 flex items-center justify-center flex-shrink-0" data-id="element-506">
                  <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" data-id="element-507">
                    <circle cx="12" cy="12" r="10" fill="#6B21A8" data-id="element-508" />
                    <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold" data-id="element-509">C7</text>
                  </svg>
                </div>
                <div data-id="element-510">
                  <p className="font-heading text-lg font-bold text-[#0F172A]" data-id="element-511">Commerce7</p>
                  <p className="text-xs text-[#64748B]" data-id="element-512">Install from the Commerce7 App Marketplace</p>
                </div>
              </div>
              <p className="text-[#475569] text-sm leading-relaxed flex-1" data-id="element-513">Get CorkShip set up in your Commerce7 store. Covers installation, Australia Post credentials, parcel sizes, creating shipments, printing labels, and manifests.</p>
              <div className="flex items-center gap-1.5 text-[#0284C7] text-sm font-semibold mt-6 group-hover:gap-2.5 transition-all" data-id="element-514">
                Read the Commerce7 guide
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4" data-id="element-515"><path d="M5 12h14" data-id="element-516" /><path d="M12 5l7 7-7 7" data-id="element-517" /></svg>
              </div>
            </div>
          </Link>
        </div>

        {/* AusPost credentials card */}
        <div className="mt-6" data-id="element-518">
          <Link to="/docs/auspost-credentials" className="no-underline group" data-id="element-519">
            <div className="bg-white rounded-2xl border border-[#E2E8F0] p-6 shadow-sm transition-all duration-200 hover:shadow-md flex items-center gap-5" data-id="element-520">
              <div className="w-12 h-12 rounded-xl bg-[#0284C7]/10 flex items-center justify-center flex-shrink-0" data-id="element-521">
                <svg viewBox="0 0 24 24" fill="none" stroke="#0284C7" strokeWidth="1.5" className="w-6 h-6" data-id="element-522"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-523" /><path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-524" /></svg>
              </div>
              <div className="flex-1" data-id="element-525">
                <p className="font-heading text-base font-bold text-[#0F172A] mb-0.5" data-id="element-526">Australia Post Credentials Guide</p>
                <p className="text-[#475569] text-sm leading-relaxed" data-id="element-527">Step-by-step guide to getting your API Key, API Secret, and Account Number from the Australia Post Developer Centre.</p>
              </div>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5 text-[#94A3B8] flex-shrink-0 group-hover:text-[#0284C7] transition-colors" data-id="element-528"><path d="M5 12h14" data-id="element-529" /><path d="M12 5l7 7-7 7" data-id="element-530" /></svg>
            </div>
          </Link>
        </div>
      </div>

      <Footer data-id="element-531" />
    </div>;
}